"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="182443" id="rncpcertificationstrategy" className="relative w-full min-h-[45vh] flex flex-col lg:flex-row bg-background overflow-hidden">
      {/* Bloc texte – gauche */}
      <div className="w-full flex flex-col justify-center px-6 py-12 z-10 !bg-[#F5EDE8] lg:w-1/2 lg:p-12 xl:p-16">
        <div ref={textRef} className={`max-w-2xl mx-auto lg:mx-0 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight font-bold mb-4 text-[hsl(343,80%,35%)] tracking-tight">
            Certification RNCP ou RS : de l'idée à l'enregistrement réussi
          </h1>

          <p className="font-sans text-base md:text-lg mb-8 text-[hsl(210,10%,23%)] max-w-xl leading-relaxed">
            Effet Conseil accompagne les porteurs de projets dans la création,
            le renouvellement et la sécurisation de leurs certifications RNCP et
            RS, en privilégiant la co-construction.
          </p>

          <Button asChild size="lg" className="!bg-[hsl(343,80%,35%)] text-white hover:!bg-[hsl(343,80%,30%)] rounded-sm font-sans text-base px-8 py-5 h-auto shadow-xl hover:shadow-2xl transition-all duration-300">
            <Link to="/contact/">
              Échanger sur votre projet
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>

      {/* Bloc image – droite */}
      <div className="w-full lg:w-1/2 relative min-h-[35vh] lg:min-h-[45vh]">
        <img src="https://effet-conseil.com/wp-content/uploads/2026/03/custom_training_solutions.webp" alt="Accompagnement certification RNCP RS" className="absolute inset-0 w-full h-full object-cover object-center" />
        <div className="hidden lg:block absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#F5EDE8]/40 to-transparent pointer-events-none" />
      </div>
    </section>;
}